import sysadmin from "./sysadmin.routes";
import functional from "./functional.routes";
import guards from "./guards.routes";

export default [...sysadmin, ...guards, ...functional];
